var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#0040FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5105_18501",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 28,
    height: 28
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5105_18501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 35.6673C22.1725 35.434 20.5392 34.9673 19.1003 34.2673C17.6614 33.5673 16.4411 32.6534 15.4393 31.5257C14.4383 30.3979 13.6753 29.09 13.1503 27.6022C12.6253 26.115 12.3628 24.4673 12.3628 22.659C14.5017 22.8729 16.31 23.2618 17.7878 23.8257C19.2656 24.3895 20.4665 25.1868 21.3905 26.2173C22.3137 27.2479 22.9795 28.5359 23.3878 30.0813C23.7961 31.6275 24.0003 33.4895 24.0003 35.6673ZM24.0003 25.8382C23.5531 25.1576 22.9456 24.4868 22.178 23.8257C21.4095 23.1645 20.5197 22.5618 19.5086 22.0173C19.6253 21.2007 19.8197 20.3548 20.092 19.4798C20.3642 18.6048 20.6947 17.7442 21.0836 16.898C21.4725 16.0525 21.9147 15.2409 22.4101 14.4632C22.9063 13.6854 23.4364 12.9757 24.0003 12.334C24.5642 12.9757 25.0942 13.6854 25.5905 14.4632C26.0859 15.2409 26.5281 16.0525 26.917 16.898C27.3058 17.7442 27.6364 18.6048 27.9086 19.4798C28.1808 20.3548 28.3753 21.2007 28.492 22.0173C27.4808 22.5423 26.5911 23.1354 25.8226 23.7965C25.055 24.4576 24.4475 25.1382 24.0003 25.8382ZM26.3336 35.2007C26.2947 33.8395 26.1928 32.5807 26.028 31.4242C25.8623 30.2668 25.6045 29.1729 25.2545 28.1423C26.1683 26.5673 27.4272 25.284 29.031 24.2923C30.6355 23.3007 32.8378 22.7562 35.6378 22.659C35.6572 25.7312 34.8359 28.3803 33.1738 30.6063C31.5109 32.8331 29.2308 34.3645 26.3336 35.2007Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.4e653649efcb21c662af6708a2845799.svg";
export { ForwardRef as ReactComponent };